


// import React from 'react';

// const Websolution = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.textSection}>
//         <h2 style={styles.title}>Why Choose Our Web Development Services?</h2>
//         <p style={styles.description}>
//          Our team creates visually stunning, highly functional websites tailored to meet your business goals. We blend creativity, technology, and strategy to build impactful digital solutions.
//         </p>
//         <p style={styles.description}>
//           Whether you need a simple landing page or a complex
//         </p>
//         <p style={styles.description}>
//  eCommerce platform, we ensure scalability, responsiveness,
//         </p>
//         <p style={styles.description}>
//           and user-centric design in every project.
//         </p>
//       </div>

//       <div style={styles.imageSection}>
//         <img src="/image/webdevelopp.jpeg" alt="AI Solutions" style={styles.image} />
//       </div>

//       <style jsx>{`
//         @media screen and (max-width: 768px) {
//           .container {
//             flex-direction: column;
//             text-align: center;
//           }
//           .textSection {
//             width: 100%;
//             margin-bottom: 20px;
//           }
//           .imageSection {
//             width: 100%;
//           }
//         }
        
//         @media screen and (max-width: 480px) {
//           .title {
//             font-size: 24px;
//           }
//           .description {
//             font-size: 14px;
//           } 
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',  
//     alignItems: 'center',  
//     padding: '20px',
//     backgroundColor: 'white',  
//     boxSizing: 'border-box',
//     height: '70vh', 
//     color: 'white', 
//   },
//   textSection: {
//     width: '40%',  
//     paddingRight: '20px',
//     textAlign: 'left',  
//   },
//   title: {
//     fontSize: '32px',
//     fontWeight: 'bold',
//     marginBottom: '20px',
//     color: 'black',
//    letterSpacing: '0',
//   },
//   description: {
//     fontSize: '16px',
//     lineHeight: '1.6',
//     marginBottom: '15px',
//     textAlign: 'justify',
//     color: 'black',
//   },
//   imageSection: {
//     width: '40%',  
//     textAlign: 'center',
//   },
//   image: {
//     width: '95%',
//     height: 'auto',
//     borderRadius: '8px',
//     boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//     marginLeft:'135px',
//   },
// };

// export default Websolution;



import React from 'react';

const WebDevSolution = () => {
  return (
    <div style={styles.container} className="webdev-container">
      <div style={styles.textSection} className="webdev-text">
        <h2 style={styles.title}>Why Choose Our Web Development Services?</h2>
        <p style={styles.description}>
          Our web development solutions help businesses build a strong digital presence 
          with fast, secure, and visually appealing websites and applications. 
          We combine creativity with the latest technologies to craft solutions 
          that align with your goals.
        </p>
        <p style={styles.description}>
          From responsive websites and e-commerce platforms to advanced web applications 
          and content management systems, we deliver tailored solutions that scale 
          with your business.
        </p>
        <p style={styles.description}>
          We follow an end-to-end approach—covering planning, design, development, 
          testing, deployment, and ongoing maintenance—to ensure you get a reliable 
          and future-ready product.
        </p>
        <p style={styles.description}>
          With a focus on user experience, performance, and security, our web 
          development services empower you to stay ahead in the digital world.
        </p>
      </div>

      <div style={styles.imageSection} className="webdev-image">
        <img 
         src="/image/webdevelopp.jpeg"   
          alt="Web Development Services" 
          style={styles.image} 
           
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 'clamp(20px, 5vw, 60px) clamp(15px, 4vw, 40px)',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    minHeight: '70vh',
    color: 'black',
    gap: 'clamp(20px, 4vw, 40px)',
    flexWrap: 'wrap',
  },
  textSection: {
    flex: '1 1 500px',
    minWidth: '300px',
    textAlign: 'left',
  },
  title: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: 'black',
    lineHeight: '1.3',
  },
  description: {
    fontSize: 'clamp(14px, 1.8vw, 16px)',
    lineHeight: '1.6',
    marginBottom: '15px',
    textAlign: 'left',
    color: 'black',
  },
  imageSection: {
    flex: '1 1 400px',
    minWidth: '300px',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    height: 'auto',
    maxWidth: '600px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    objectFit: 'contain',
  },
};

// Media queries
const mediaQueries = `
  @media screen and (max-width: 1024px) {
    .webdev-container {
      flex-direction: column;
      text-align: center;
    }
    .webdev-text, .webdev-image {
      width: 100% !important;
      text-align: center;
      padding: 0;
    }
    .webdev-text {
      text-align: center;
    }
    .webdev-text p {
      text-align: center;
    }
    .webdev-image img {
      margin: 0 auto;
      max-width: 90%;
    }
  }

  @media screen and (max-width: 768px) {
    .webdev-container {
      padding: 30px 15px;
      gap: 25px;
    }
    .webdev-text h2 {
      font-size: 28px !important;
    }
  }

  @media screen and (max-width: 480px) {
    .webdev-container {
      padding: 20px 10px;
      gap: 20px;
    }
    .webdev-text h2 {
      font-size: 22px !important;
      line-height: 1.3;
      margin-bottom: 15px;
    }
    .webdev-text p {
      font-size: 14px !important;
      line-height: 1.5;
      margin-bottom: 12px;
      text-align: left;
    }
    .webdev-image img {
      max-width: 100%;
    }
  }
`;

if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = mediaQueries;
  document.head.appendChild(styleSheet);
}

export default WebDevSolution;
